// eslint-disable-next-line import/no-anonymous-default-export
export default [
  {
    text: "Add",
    disabled: false,
    path: "/expenses/add",
  },
  {
    text: "History",
    disabled: false,
    path: "/expenses/list",
  },
  {
    text: "Setting",
    disabled: false,
    path: "/expenses/settings",
  },
];
